import(/* webpackMode: "eager" */ './hero-banner-block.scss')
import { Loader } from '@googlemaps/js-api-loader'

const widget = $('.widget.hero-banner-block')
const desktopSearchBreakpoint = 1024
const stillLoadingTimeout = setTimeout(function () {
  widget.addClass('still-loading')
}, 250)

  ; (async () => {
    // Fix error if widget is not found
    // Note: Only necessary if this widget script is loaded on pages where the widget is not present, such as the 'global.js' file, which is loaded on every page.
    if (widget.length === 0) {
      console.warn('Hero Banner Block widget not found')
      return
    }

    const { default: moment } = await import('moment')
    const { default: Swiper } = await import('../../plugins/swiper/swiper')
    await import('../../plugins/semantic/form')
    await Promise.all([
      import('../../plugins/swiper/swiper.scss'),
      import('../../scripts/dbs/dbs.semantic.form'),
      import('../../plugins/semantic/table.css'),
      import('../../plugins/semantic/popup.css'),
      import('../../plugins/semantic/icon.css'),
      import('../../plugins/semantic/popup'),
      import('../../plugins/semantic/modal.scss'),
      import('../../plugins/semantic/modal'),
      import('../../plugins/semantic/dimmer.scss'),
      import('../../plugins/semantic/dimmer'),
      import('../../plugins/semantic-calendar/calendar'),
      import('../../plugins/semantic-calendar/calendar.css'),
      import('../../plugins/semantic/search'),
      import('../../plugins/semantic/search.scss'),
      import('../../plugins/semantic/api'),
      import('../../plugins/semantic/transition.css'),
      import('../../plugins/semantic/transition'),
      import('../../plugins/daterangepicker/daterangepicker'),
      import('../../plugins/daterangepicker/daterangepicker.scss'),
      import('../guest-selector/guest-selector'),
      import('../guest-selector/guest-selector.scss'),
      import('../location-typeahead/location-typeahead.scss'),
    ])

    widget.data('widget', new HeroBannerBlock(widget, moment, Swiper))
    widget.data('widget').init()

    // NOTE: Handle click and touch events on widget swipers to manually trigger hide on date range picker if it is open.
    // This is a workaround as Swiper is intercepting events like mousedown or touchstart, preventing the date range picker from closing.
    // See https://discoveryparks.atlassian.net/browse/HPR-337
    widget.on('click touchstart', function (e) {
      // We do not need to handle this on mobile, it has a different UI.
      if (window.innerWidth < desktopSearchBreakpoint) {
        return
      }

      const $calendar = $('.daterangepicker')
      // NOTE HPR-393 We also need to check if e.target is a 'th' element or a span inside a 'th' element
      // Seems like the daterangepicker plugin does something with the prev/next calendar buttons that is causing
      // our other conditional checks to fail. So, we need these separate checks to ensure the calendar is not closed
      // when clicking prev/next buttons.
      const isInsideCalendar =
        $calendar.is(e.target) ||
        $calendar.has(e.target).length > 0 ||
        e.target.tagName === 'TH' ||
        $(e.target).closest('th').length > 0

      // Close the picker if clicked outside of it
      if (!isInsideCalendar) {
        widget.find('.date-selector').each(function () {
          const picker = $(this).data('daterangepicker')
          if (picker && picker.isShowing) {
            picker.hide()
          }
        })
      }
    })
  })()

function HeroBannerBlock(el, moment, Swiper) {
  const self = this
  self.el = $(el)
  self.events = new dbs.events()
  self.bodyScrollPos = 0
  self.paginationContainer = self.el.find('.js-pagination-container')
  self.arriveInput = self.el.find('.arrive.input')
  self.departInput = self.el.find('.depart.input')
  self.mobileSearchLayout = true

  const todayDate = new Date()
  const tomorrowDate = moment().add(1, 'days').toDate()
  const maxDate = new moment().add(1, 'years').toDate()
  const isMobileView = $('body').hasClass('is-mobile-view')
  self.today = todayDate
  self.tomorrow = tomorrowDate
  self.maxDate = new moment().add(1, 'y').toDate()
  self.currentZoom = 0;
  const noLocationError = self.el.find('.location-error')
  const locationProxyButton = self.el.find('[aria-controls="search-panel-location"]')

  function showNoLocationSelectedError() {
    noLocationError.css('display', 'inline-block')
    locationProxyButton?.addClass('is-invalid')
  }

  function hideNoLocationSelectedError() {
    noLocationError.css('display', 'none')
    locationProxyButton?.removeClass('is-invalid')
  }

  function showGeoLocationUnavailableError() {
    $('.geolocation-popup').modal({ closable: true }).modal('show')
  }

  function handleGeoLocationPositionResponse(response) {
    const redirectUrl = self.el.find('.current-location').attr('data-redirect')
    const arriveDate = moment(self.arriveInput.val(), 'YYYY-MM-DD')
    const departDate = moment(self.departInput.val(), 'YYYY-MM-DD')

    let filters = {
      lat: response.coords.latitude,
      lng: response.coords.longitude,
      //hideDistance: 'false', // string: ['true'|'false'|'mapMove']. Default = 'mapMove'.
      arrive: arriveDate.format('YYYY-MM-DD'),
      depart: departDate.format('YYYY-MM-DD'),
      adults: self.el.find('.adults.input').val(),
      kids: self.el.find('.kids.input').val(),
      infants: self.el.find('.infants.input').val(),
      guests: self.el.find('.guests.input').val(),
      zoom: 8,
      isGeoLocationSearch: true,
    }

    let invalidArrive = false
    if (filters.arrive.toLowerCase() === 'invalid date') {
      invalidArrive = true
      filters.arrive = moment(todayDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
    }

    if (filters.depart.toLowerCase() === 'invalid date') {
      if (!invalidArrive) {
        filters.depart = moment(self.arriveInput.val(), 'DD/MM/YYYY').add(1, 'd').format('YYYY-MM-DD')
      } else {
        filters.depart = moment(tomorrowDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
      }
    }

    window.location.href = redirectUrl + '?' + $.param(filters)
  }

  function handleSubmitButtonClick(e) {
    e.preventDefault()

    const selectedLocation = self.typeahead.selectedItem
    const arriveDate = moment(self.arriveInput.val(), 'YYYY-MM-DD')
    const departDate = moment(self.departInput.val(), 'YYYY-MM-DD')

    if (selectedLocation.isPark) {
      const filters = {
        adults: self.el.find('.adults.input').val(),
        kids: self.el.find('.kids.input').val(),
        infants: self.el.find('.infants.input').val(),
        guests: self.el.find('.guests.input').val(),
      }

      if (!isNaN(arriveDate)) {
        filters.arrive = arriveDate.format('YYYY-MM-DD')
      }

      if (!isNaN(departDate)) {
        filters.depart = departDate.format('YYYY-MM-DD')
      }

      window.location.href = selectedLocation.url + '?' + $.param(filters)
      return
    }

    if (selectedLocation.isLocation) {
      let dateToday = new Date()
      dateToday.setHours(0, 0, 0)

      let defaultArrivalDate = new Date()
      defaultArrivalDate.setHours(0, 0, 0)
      defaultArrivalDate.setDate(dateToday.getDate() + 1)

      let defaultDepartureDate = new Date()
      defaultDepartureDate.setHours(0, 0, 0)
      defaultDepartureDate.setDate(dateToday.getDate() + 2)

      self.typeahead.dbsPlacesService.getDetails(
        {
          placeId: selectedLocation.id,
          fields: ['geometry'],
        },
        function (place) {
          let filters = {
            placeId: selectedLocation.id,
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
            query: selectedLocation.label,
            adults: self.el.find('.adults.input').val(),
            kids: self.el.find('.kids.input').val(),
            infants: self.el.find('.infants.input').val(),
            guests: self.el.find('.guests.input').val(),
            zoom: 8, // TODO Make this a big smarter
          }

          if (!isNaN(arriveDate)) {
            filters.arrive = arriveDate.format('YYYY-MM-DD')
          }

          if (!isNaN(departDate)) {
            filters.depart = departDate.format('YYYY-MM-DD')
          }

          const url = self.el.find('.search-form').attr('data-location')
          window.location.href = url + '?' + $.param(filters)
        },
      )
      return
    }

    return showNoLocationSelectedError()
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('HeroBannerBlock init', self)
    }
    self.el.css('opacity', 1)

    self.initSearchForm()
    self.setVideoSource()
    self.initSwiper()
    self.bindEvents()
  }

  self.setVideoSource = function () {
    // Find all video elements in the widget
    const videoEls = self.el.find('video')
    if (videoEls.length === 0) return

    // Set the video source based on the screen size
    const isMobile = window.innerWidth < 640
    const isTablet = window.innerWidth >= 640 && window.innerWidth < desktopSearchBreakpoint
    videoEls.each(function (i, el) {
      const videoEl = $(el)

      // Video soruces
      const mobileSrc = videoEl.attr('data-src-mobile')
      const tabletSrc = videoEl.attr('data-src-tablet')
      const desktopSrc = videoEl.attr('data-src-desktop')

      // Poster sources
      const mobilePoster = videoEl.attr('data-poster-mobile')
      const tabletPoster = videoEl.attr('data-poster-tablet')
      const desktopPoster = videoEl.attr('data-poster-desktop')

      // Set video src
      let src = desktopSrc // default
      if (isMobile && (mobileSrc || tabletSrc)) {
        src = mobileSrc || tabletSrc
      } else if (isTablet && tabletSrc) {
        src = tabletSrc
      }

      // Select poster image
      let poster = desktopPoster // default
      if (isMobile && (mobilePoster || tabletPoster)) {
        poster = mobilePoster || tabletPoster
      } else if (isTablet && tabletPoster) {
        poster = tabletPoster
      }

      if (src) {
        videoEl.attr('src', src)
        if (poster) videoEl.attr('poster', poster)
        videoEl.attr('muted', true) // NOTE: Muted is required for autoplay to work on mobile
        videoEl.attr('autoplay', true)
        videoEl.attr('playsinline', true)
        videoEl[0].load()
      }
    })
  }

  self.bindEvents = function () {
    // NOTE: Swiper can duplicate slides, so do not bind directly to the play/pause button
    self.el.on('click', '.js-video-playpause', function (e) {
      const pauseplayButton = $(this)
      const videoId = pauseplayButton.attr('aria-controls')
      // NOTE: swiper can duplicate slides, so we need to find all video elements with the same id
      const videoEl = self.el.find(`[id="${videoId}"]`)

      if (!videoEl) {
        console.warn('No video found', e)
        return
      }

      // NOTE: Swiper duplicates slides (because using 'fade' transition), because of this, if a user pauses a video in the slide,
      // the transition can have the paused video frame jump as its jumping to the duplicate slide to perform the transition between the slides.
      // There is nothing we can do about this if using 'fade' transitions.
      pauseplayButton.toggleClass('paused')
      if (pauseplayButton.hasClass('paused')) {
        videoEl.each((i, el) => el.pause())
      } else {
        videoEl.each((i, el) => el.play())
      }
    })

    // NOTE: Handle show/hide of search container on mobile
    self.el.on('click', '.js-search-container-close', self.hideSearchContainer)
    self.el.on('click', '.js-search-container-open', self.showSearchContainer)

    self.setPaginationContainerBottom()

    // if screen is 1024px or greater, show search container and all search panels
    if (window.innerWidth >= desktopSearchBreakpoint) {
      self.showSearchContainer()
      self.showAllSearchPanels()
      self.mobileSearchLayout = false
    }

    self.el.on('click', '.js-row-proxy', self.handleSearchRowProxyClick)
    self.el.on('click', '.js-search-panel-close', self.handleSearchPanelCloseClick)


    if (window.innerWidth <= 1440 && window.innerHeight <= 900) {
      self.applyCalendarScaling(self.getZoomLevel());
      self.currentZoom = self.getZoomLevel();
    }
    // NOTE: On mobile, if the keyboard is opened, this will trigger a 'resize' event, so we need to account for that.
    // NOTE: Date picker is hidden by plugin on screen resize, so 'When' panel will shown empty if opened during screen resize.
    let lastKnownInnerWidth = window.innerWidth
    let imageResizeTimeout;
    /*
    function swapImageOnResize() {
      const img = self.el.find('img[data-mobile-image]');
      if (!img) return;

      const width = window.innerWidth;
      let newSrc;

      if (width <= 640) {
        newSrc = img.attr('data-mobile-image');
      } else if (width <= 1220) {
        newSrc = img.attr('data-tablet-image');
      } else {
        newSrc = img.attr('data-desktop-image');
      }

      if (newSrc && newSrc != "" && img.src !== newSrc) {
        img.src = newSrc;
      }
    }
    swapImageOnResize();
    */
    window.addEventListener('resize', function () {
      const currentWidth = window.innerWidth
      //clearTimeout(imageResizeTimeout);
      //imageResizeTimeout = setTimeout(swapImageOnResize, 100);
      //swapImageOnResize();
      const zoomLevel = self.getZoomLevel();

      if (zoomLevel !== self.currentZoom) {
        self.applyCalendarScaling(zoomLevel)
        self.currentZoom = zoomLevel;
      }
      // Prevent breakpoint running logic if no breakpoint crossing
      const wasDesktop = lastKnownInnerWidth >= desktopSearchBreakpoint
      const isDesktop = currentWidth >= desktopSearchBreakpoint
      if (wasDesktop === isDesktop) {
        // Width changed, but no breakpoint crossing, so skip layout logic
        self.setPaginationContainerBottom()
        initDateSelectorCalendar()
        lastKnownInnerWidth = currentWidth
        return
      }

      // Breakpoint crossed - so perform layout updates
      self.setPaginationContainerBottom()
      initDateSelectorCalendar()

      if (isDesktop) {
        self.showSearchContainer()
        self.showAllSearchPanels()
        self.mobileSearchLayout = false
      } else {
        if (!self.mobileSearchLayout) {
          self.hideSearchContainer()
        }

        self.hideAllSearchPanels()
        self.mobileSearchLayout = true
        self.removeZoomScaling()
      }
      self.applyCalendarScaling(zoomLevel)
      lastKnownInnerWidth = currentWidth


    })

    self.el.find('.js-reset-form').on('click', function (e) {
      window.dbs.globalEvents.emit('HeroBannerBlockSearch:ResetForm')
      self.dateSelector.data('daterangepicker').clickCancel()
    })

    // zoom size calendar scaling handler

  }

  self.showSearchContainer = function () {
    self.el.find('.js-search-container').attr('aria-hidden', 'false')
    if (window.innerWidth < desktopSearchBreakpoint) {
      $('body').addClass('has-mobile-search-shown')
      $('.smartbanner').attr('hidden', 'hidden')
      $('.widget.alert-banner').attr('hidden', 'hidden')
      // Save current scroll position
      self.bodyScrollPos = window.scrollY
      // Set body styles to prevent scrolling
      document.body.style.position = 'fixed'
      document.body.style.top = `-${self.bodyScrollPos}px`
      document.body.style.left = '0'
      document.body.style.right = '0'
      document.body.style.overflow = 'hidden'
    } else {
      $('body').removeClass('has-mobile-search-shown')

      // Reset body styles to allow scrolling
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.left = ''
      document.body.style.right = ''
      document.body.style.overflow = ''
      // Reset scroll position to the saved position
      window.scrollTo(0, self.bodyScrollPos)
    }
  }

  self.hideSearchContainer = function () {
    self.el.find('.js-search-container').attr('aria-hidden', 'true')
    $('body').removeClass('has-mobile-search-shown')
    $('.smartbanner').removeAttr('hidden')
    $('.widget.alert-banner').removeAttr('hidden')
    // Reset body styles to allow scrolling
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.left = ''
    document.body.style.right = ''
    document.body.style.overflow = ''
    // Reset scroll position to the saved position
    window.scrollTo(0, self.bodyScrollPos)
  }

  self.handleSearchPanelCloseClick = function (e) {
    const panel = $(e.currentTarget).closest('.js-search-panel')
    panel.attr('aria-hidden', 'true')
  }

  self.showAllSearchPanels = function () {
    self.el.find('.js-search-panel').attr('aria-hidden', 'false')
  }

  self.hideAllSearchPanels = function () {
    self.el.find('.js-search-panel').attr('aria-hidden', 'true')
  }

  self.handleSearchRowProxyClick = function (e) {
    const proxy = $(this)
    const panel = proxy.attr('aria-controls')
    const panelEl = self.el.find(`#${panel}`)
    panelEl.attr('aria-hidden', 'false')

    // Show date picker on mobile
    // i.e. 'click' the bound trigger element that displays the date range picker when we open our search panel
    if (panel === 'search-panel-dates') {
      setTimeout(function () {
        // Ensure date selector is visible
        self.dateSelector.trigger('click')
      }, 0)
    } else if (panel === 'search-panel-location') {
      // NOTE: Must delay focus to ensure the panel has completed transition the input to actually receive focus
      setTimeout(function () {
        // Set focus on location typeahead input
        const locationTypeahead = panelEl.find('#location-typeahead')
        if (locationTypeahead.length) {
          // jQuery returns a jQuery object, so use [0]
          locationTypeahead[0].focus()
        }
      }, 400)
    }
  }

  self.initSwiper = function () {
    // NOTE: Swiper can have nested sliders, so we need to find the first swiper instance
    const swiperEl = self.el.find('.swiper').first()
    // Find all slides in the swiper
    const slides = swiperEl.find('.swiper-slide')
    swiperEl.attr('data-slides-count', slides.length)

    // Show pagination container if there are multiple slides
    if (slides.length > 1) {
      self.paginationContainer.removeClass('!invisible')
    }

    // Get customisable configurations
    let transitionSpeed = parseInt(swiperEl.attr('data-transition-speed'))
    transitionSpeed = transitionSpeed !== NaN ? transitionSpeed : 5000

    let autoplayDelay = parseInt(swiperEl.attr('data-autoplay-delay'))
    autoplayDelay = Number.isNaN(autoplayDelay) ? undefined : autoplayDelay || 5000

    // Enable autoplay if delay is not 'disabled'
    let autoplay = false
    if (typeof autoplayDelay === 'number' && slides.length > 1) {
      autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: true,
        pauseOnMouseEnter: true, // NOTE this does not work. Maybe because old swiper version?
      }
    }

    self.swiper = new Swiper(swiperEl, {
      loop: true,
      effect: 'fade', // See: https://swiperjs.com/swiper-api#fade-effect
      crossFade: true,
      speed: transitionSpeed,
      autoplay,
      pagination: {
        el: self.el.find('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
    })

    // Handle autoplay start/stop
    // See: https://swiperjs.com/swiper-api#autoplay
    self.pauseplayButton = self.el.find('.js-pauseplay')
    if (typeof autoplayDelay === 'number' && self.pauseplayButton.length) {
      self.pauseplayButton.on('click', function () {
        if (self.swiper.autoplay.running) {
          self.swiper.autoplay.stop()
        } else {
          self.swiper.autoplay.start()
        }
      })

      // NOTE Using events to handle css class updates as interaction on slider also triggers autoplay stop
      self.swiper.on('autoplayStart', function () {
        self.pauseplayButton.removeClass('paused')
      })

      self.swiper.on('autoplayStop', function () {
        self.pauseplayButton.addClass('paused')
      })
    }

    // NOTE: On slide change, set pagination container bottom position to ensure it displays above the active slide content
    self.swiper.on('slideChange', function () {
      self.setPaginationContainerBottom()
    })
  }

  self.setPaginationContainerBottom = function () {
    const activeSlideContentHeight = self.getActiveSlideContentHeight()

    // NOTE: If content height is 0, assume its hidden, so remove property to fallback to CSS default
    if (activeSlideContentHeight === 0) {
      self.paginationContainer.css('bottom', '')
      return
    }

    self.paginationContainer.css('bottom', activeSlideContentHeight + 'px')
  }

  self.getActiveSlideContentHeight = function () {
    const activeSlide = self.swiper.slides[self.swiper.activeIndex]
    const activeSlideContent = $(activeSlide).find('.js-content')[0]
    const activeSlideContentHeight = activeSlideContent.offsetHeight
    return activeSlideContentHeight
  }

  self.initSearchForm = function () {
    const googleMapsApi = new Loader({
      apiKey: GOOGLE_MAPS_API_KEY,
      version: '3.exp',
      libraries: ['places'],
    })

    googleMapsApi.load().then(async (google) => {
      const { default: typeahead } = await import('../location-typeahead/location-typeahead')

      const searchFormContainerOverlay = self.el.find('.loading-overlay')
      searchFormContainerOverlay[0].onanimationend = () => searchFormContainerOverlay.remove()

      clearTimeout(stillLoadingTimeout)

      self.el.removeClass('loading still-loading')

      self.typeahead = new typeahead(self.el.find('.location-typeahead'), google)

      self.typeahead.init()

      self.typeahead.events.subscribe('LocationTypeahead: selected', () => {
        hideNoLocationSelectedError()
        self.setSelectedLocation(self.typeahead.selectedItem)
        if (window.innerWidth < desktopSearchBreakpoint) {
          self.hideAllSearchPanels()
        }
      })

      self.typeahead.events.subscribe('LocationTypeahead: response', hideNoLocationSelectedError)

      self.typeahead.events.subscribe('LocationTypeahead: clear', () => {
        self.setSelectedLocation(null)
      })

      self.typeahead.geolocation.events.subscribe('Geolocation:getPosition_error', showGeoLocationUnavailableError)

      self.typeahead.geolocation.events.subscribe('Geolocation:getPosition_response', handleGeoLocationPositionResponse)
    })

    initDateSelectorCalendar()

    self.el.find('.submit.button').click(handleSubmitButtonClick)
  }

  self.setSelectedLocation = function (location) {
    const locationProxy = self.el.find('.js-location-display-proxy')
    if (!location) {
      const initialLabel = locationProxy?.attr('data-initial')
      locationProxy?.text(initialLabel)
    } else {
      locationProxy?.text(location.label)
    }
  }

  function initDateSelectorCalendar() {
    self.dateSelector = self.el.find('.date-selector')

    // See: https://www.daterangepicker.com/#options
    self.dateSelector.daterangepicker(
      {
        autoApply: false,
        minDate: self.today,
        maxDate: self.maxDate,
        startDate: self.today,
        endDate: self.tomorrow,
        parentEl:
          window.innerWidth < desktopSearchBreakpoint
            ? self.dateSelector.closest('.field')
            : self.dateSelector.closest('.ui.form'),
        locale: {
          format: 'D MMM',
          applyLabel: 'Select Dates',
          cancelLabel: 'Clear',
        },
        transition: window.innerWidth < desktopSearchBreakpoint ? undefined : 'fade',
        minTransitionWidth: window.innerWidth < desktopSearchBreakpoint ? 0 : desktopSearchBreakpoint,
        buttonClasses: '',
        applyButtonClasses: 'ui button primary',
        cancelButtonClasses: 'ui button link-button',
      },
      function (startDate, endDate) {
        // NOT USED - setDateSelectorDates(startDate, endDate)
        // We are listening for the 'apply.daterangepicker' event to set selected dates. This allows us to handle the case where the
        // user opens the date picker, and just clicks the 'apply' button without selecting a date range. This callback function does not
        // run in that case, so would not corectly set the selected dates.
      },
    )


    // NOTES
    // Date picker will update its dates on a valid selection, regardless of if the 'apply' button is clicked. This is the plugins behaviour.
    // So, that means if a user opens the date picker, selects a valid date range, and then closes the date picker (other that clicking 'apply' or 'cancel' buttons),
    // the valid selected dates will be set as the selected dates.
    // If the users clicks the 'clear' button, the dates will be set to the today's date.
    // If the user clicks the 'apply' button, the dates will be set to the selected date range.
    // If the user does not make a valid date range selection, the dates will remain as previously selected on picker close.

    self.dateSelector.on('show.daterangepicker', function(event,picker) {

    });
    self.dateSelector.on('cancel.daterangepicker', function (event, picker) {
      // Reset date selector
      self.dateSelector.data('daterangepicker').setStartDate(self.today)
      self.dateSelector.data('daterangepicker').setEndDate(self.tomorrow)
      // Clear input values
      self.dateSelector.val('')
      // Update display text
      setDateSelectorDates(null, null)
    })

    self.dateSelector.on('apply.daterangepicker', function (event, picker) {
      setDateSelectorDates(picker.startDate, picker.endDate)
    })

    self.dateSelector.on('hide.daterangepicker', function (event, picker) {
      // NOTE: Clicking search panel header will trigger the date picker hide event (because 'outsideClick' handled by plugin),
      // so we need to ensure that the search panel is hidden if it is currently visible, to prevent an empty panel remaining open.
      // HACK: The setTimeout is used to (try) prevent the click bubbling up to trigger elements underneath the date picker, because the
      // date picker can close before the click event is processed. Adjust the timeout to introcduce longer delays if click is not being prevented.
      if (window.innerWidth < desktopSearchBreakpoint) {
        setTimeout(function () {
          const searchPanel = self.el.find('#search-panel-dates')
          if (searchPanel.attr('aria-hidden') === 'false') {
            self.hideAllSearchPanels()
          }
        }, 60)
      }
    })
  }

  function setDateSelectorDates(dateFrom, dateTo) {

    const dateRangePickerProxy = self.el.find('.js-date-range-picker-proxy')
    const dateRangePicker = self.dateSelector.find('.date-range-picker')
    if (!dateFrom) {
      const initialLabel = dateRangePickerProxy?.attr('data-initial')
      // Update display text
      dateRangePickerProxy?.text(initialLabel)
      dateRangePicker?.addClass('empty').text(initialLabel)
      // Update input values
      self.arriveInput.val('')
      self.departInput.val('')
    } else {
      const totalNights = dateTo.diff(dateFrom, 'days')
      const totalNightsText = totalNights === 1 ? `${totalNights} night` : `${totalNights} nights`
      const selectedDateRange =
        moment(dateFrom).format('DD MMM') + ' - ' + moment(dateTo).format('DD MMM') + ' (' + totalNightsText + ')'
      // Update display text
      dateRangePickerProxy?.text(selectedDateRange)
      dateRangePicker?.removeClass('empty').text(selectedDateRange)
      // Update input values
      self.arriveInput.val(moment(dateFrom).format('YYYY-MM-DD'))
      self.departInput.val(moment(dateTo).format('YYYY-MM-DD'))
    }

    if (window.innerWidth < desktopSearchBreakpoint) {
      self.hideAllSearchPanels()
    }
  }

  self.getZoomViaElement = () => {
    const testEl = document.createElement('div');
    testEl.style.width = '100px';
    testEl.style.height = '100px';
    testEl.style.position = 'absolute';
    testEl.style.visibility = 'hidden';

    document.body.appendChild(testEl);
    const zoom = testEl.offsetWidth / 100;
    document.body.removeChild(testEl);

    return Math.round(zoom * 100);
  }

  self.getZoomLevel = () => {
    return window.devicePixelRatio ?  Math.round(window.devicePixelRatio * 100) : self.getZoomViaElement();
  }

  self.removeZoomScaling = () => {
    const datePicker = self.el.find('.daterangepicker');
    const typeAheadResultsPicker = self.el.find('.results.drop-up');

    const datePickerClasses = datePicker.attr('class').split(/\s+/);
    const datePickerToRemove = datePickerClasses.filter(cls => cls.startsWith('scale-'));
    datePicker.removeClass(datePickerToRemove.join(' '));

    const typeAheadResultsPickerClasses = typeAheadResultsPicker.attr('class').split(/\s+/);
    const typeAheadToRemove = typeAheadResultsPickerClasses.filter(cls => cls.startsWith('scale-'));
    typeAheadResultsPicker.removeClass(typeAheadToRemove.join(' '));
  }

  window.disableZoomScaling = false;
  self.applyCalendarScaling = (zoomLevel) => {
    if(window.disableZoomScaling){
      return;
    }
    if($('#mobile_search_detector').is(':visible')) {
      self.removeZoomScaling();
      return; // we're zoomed in super far, so far the mobile view is visible - we don't want the scaling to apply to the popovers
    }

    // Width max/mins we want to handle and not apply scaling in those circumstances
    const currentWidth = window.innerWidth
    const currentHeight = window.innerHeight
    if (currentWidth >= 1440 && currentHeight >= 900) {
      self.removeZoomScaling();
    }

    if(zoomLevel < 100) {
      return;
    }

    if (zoomLevel > 200) {
      zoomLevel = 200;
    }
    const zoomLevels = [100, 110, 125, 138, 150, 175,200];
    const snappedZoom = zoomLevels.reduce((closest, level) => Math.abs(level - zoomLevel) < Math.abs(closest - zoomLevel) ? level : closest);

    if (process.env.NODE_ENV === 'development') {
    console.log('Scaling to ' + snappedZoom)
    }
    const scaleClass = 'scale-' + snappedZoom;
    const datePicker = self.el.find('.daterangepicker');
    const typeAheadResultsPicker = self.el.find('.results.drop-up');
    datePicker.addClass(scaleClass);
    typeAheadResultsPicker.addClass(scaleClass);

    /*
    setTimeout(function() {
      let a = $('.daterangepicker');
      let b = $('.results.drop-up');
      a.addClass(scaleClass);
      b.addClass(scaleClass);

    },250)
    */
  }
}
